import { Maybe } from '@csp/csp-common-model';
import { createContext } from 'react';
import { NotificationsContextState } from '../model/NotificationsContextState';

export const NotificationsContext = createContext<Maybe<NotificationsContextState>>(undefined);
